import { render, staticRenderFns } from "./scoreInfo.vue?vue&type=template&id=8af83bf8&scoped=true&"
import script from "./scoreInfo.vue?vue&type=script&lang=js&"
export * from "./scoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./scoreInfo.vue?vue&type=style&index=0&id=8af83bf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af83bf8",
  null
  
)

export default component.exports